const shouldShowApplicationFlow = (): boolean => {
  return import.meta.env.PUBLIC_SHOW_APPLICATION_FLOW === 'true'
}

export default shouldShowApplicationFlow
